"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showFeedbackSurvey = exports.getFeedbackLoader = void 0;

var _feedbackLoader = _interopRequireDefault(require("feedback-loader"));

var getFeedbackLoader = function getFeedbackLoader() {
  return _feedbackLoader.default;
};

exports.getFeedbackLoader = getFeedbackLoader;

var showFeedbackSurvey = function showFeedbackSurvey(feedbackSurveyId) {
  if (!window.hsFeedback || !window.hsFeedback.loadSurvey) {
    return;
  }

  window.hsFeedback.loadSurvey('CSAT', feedbackSurveyId);
};

exports.showFeedbackSurvey = showFeedbackSurvey;